import React, { useState, useEffect } from "react";
import API from "../axios";
import { motion } from "framer-motion";
import "../style/career.css";

const Career = () => {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchCareers = async () => {
    try {
      setLoading(true);
      const res = await API.get("/careers");
      setData(res.data);
    } catch (err) {
      console.error("Error fetching careers", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCareers();
  }, []);

  // 🔹 Animation
  const cardVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.7 }
    }
  };

  return (
    <div className="container mt-3 pt-lg-3">

      <h3 className="text-center mb-lg-5 mb-3 career-title">Careers</h3>

      {loading ? (
        <div className="text-center fw-bold">Loading...</div>
      ) : data.length === 0 ? (
        <div className="text-center fw-bold">No Openings</div>
      ) : (
        <div className="row">

          {data.map((item, index) => (
            <motion.div
              key={item.id}
              className="col-md-6 col-lg-4 mb-4"
              variants={cardVariant}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              <div className="career-card shadow">

                {/* TITLE */}
                <div className="career-role">
                  {item.role}
                </div>

                {/* DESCRIPTION */}
                <div className="career-desc">
                  {item.description}
                </div>

              </div>
            </motion.div>
          ))}

          <div className="career-mail text-center mt-lg-4 mt-2 mb-3">
            Please Share Resume to –{" "}
           <span
                className="career-mail-link"
                onClick={() =>
                  window.location.href =
                    "mailto:careers@pothysswarnamahal.com"
                }
                style={{ cursor: "pointer" }}
              >
                careers@pothysswarnamahal.com
              </span>
          </div>

        </div>


        
      )}
    </div>
  );
};

export default Career;